
import PropTypes from 'prop-types';

const loadEntitySuffix = '@LOAD';
const loadingEntitySuffix = '@LOADING';
const loadedEntitySuffix = '@LOADED';
const loadEntityFailedSuffix = '@LOAD_FAILED';
const loadEntityFinallySuffix = '@LOAD_FINALLY';
const resetEntityErrorSuffix = '@RESET_ERROR';

const loadEntitiesSuffix = '@MLOAD';
const loadingEntitiesSuffix = '@MLOADING';
const loadedEntitiesSuffix = '@MLOADED';
const loadEntitiesFailedSuffix = '@MLOAD_FAILED';
const loadEntitiesFinallySuffix = '@MLOAD_FINALLY';
const resetEntitiesErrorSuffix = '@MRESET_ERROR';

const processEntitySuffix = '@PROCESS';
const processingEntitySuffix = '@PROCESSING';
const processedEntitySuffix = '@PROCESSED';
const processEntityFailedSuffix = '@PROCESS_FAILED';
const processEntityFinallySuffix = '@PROCESS_FINALLY';

const processEntitiesSuffix = '@MPROCESS';
const processingEntitiesSuffix = '@MPROCESSING';
const processedEntitiesSuffix = '@MPROCESSED';
const processEntitiesFailedSuffix = '@MPROCESS_FAILED';
const processEntitiesFinallySuffix = '@MPROCESS_FINALLY';

const loadingEntitySuffixRe = new RegExp(`${loadingEntitySuffix}$`);
const loadedEntitySuffixRe = new RegExp(`${loadedEntitySuffix}$`);
const loadEntityFailedSuffixRe = new RegExp(`${loadEntityFailedSuffix}$`);
const loadEntityFinallySuffixRe = new RegExp(`${loadEntityFinallySuffix}$`);
const resetEntityErrorSuffixRe = new RegExp(`${resetEntityErrorSuffix}$`);

const loadingEntitiesSuffixRe = new RegExp(`${loadingEntitiesSuffix}$`);
const loadedEntitiesSuffixRe = new RegExp(`${loadedEntitiesSuffix}$`);
const loadEntitiesFailedSuffixRe = new RegExp(`${loadEntitiesFailedSuffix}$`);
const loadEntitiesFinallySuffixRe = new RegExp(`${loadEntitiesFinallySuffix}$`);
const resetEntitiesErrorSuffixRe = new RegExp(`${resetEntitiesErrorSuffix}$`);

const processingEntitySuffixRe = new RegExp(`${processingEntitySuffix}$`);
const processedEntitySuffixRe = new RegExp(`${processedEntitySuffix}$`);
const processEntityFailedSuffixRe = new RegExp(`${processEntityFailedSuffix}$`);
const processEntityFinallySuffixRe = new RegExp(`${processEntityFinallySuffix}$`);

const processingEntitiesSuffixRe = new RegExp(`${processingEntitiesSuffix}$`);
const processedEntitiesSuffixRe = new RegExp(`${processedEntitiesSuffix}$`);
const processEntitiesFailedSuffixRe = new RegExp(`${processEntitiesFailedSuffix}$`);
const processEntitiesFinallySuffixRe = new RegExp(`${processEntitiesFinallySuffix}$`);

export const LOADING_FLAG = '_loading';
export const PROCESSING_FLAG = '_processing';
export const FINISHED_FLAG = '_finished';
export const ERROR_FLAG = '_error';

export const removeFlags = (entity) => {
  const { [LOADING_FLAG]: l, [PROCESSING_FLAG]: p, [ERROR_FLAG]: e, [FINISHED_FLAG]: f, ...rest } = entity;
  return rest;
};

const defaultInitialState = {
  ids: [],
  [LOADING_FLAG]: false,
  [PROCESSING_FLAG]: false,
  [FINISHED_FLAG]: null,
  [ERROR_FLAG]: null,
  entities: {
    /*
    [id]: {
      [LOADING_FLAG]: false,
      [PROCESSING_FLAG]: false,
      [ERROR_FLAG]: null,
      ...data
    }
    */
  }
};

export default (stateNamespace, initialState = defaultInitialState) => {
  const actionNamespace = stateNamespace.toUpperCase();
  const actionNamespaceRe = new RegExp(`^${actionNamespace}`);

  const createReducer = reducer => (prevState = initialState, action) => {
    const state = reducer(prevState, action);

    if (!actionNamespaceRe.test(action.type)) {
      return state;
    }

    switch (true) {
      case loadingEntitySuffixRe.test(action.type): {
        if (!(action.payload && action.payload.id)) {
          console.warn('Missing action.payload.id, skipping ho-reducer', action);
          return {
            ...state,
            [LOADING_FLAG]: true,
            [PROCESSING_FLAG]: false,
            [FINISHED_FLAG]: false,
            [ERROR_FLAG]: null,
          };
        }

        return {
          ...state,
          [LOADING_FLAG]: false,
          [PROCESSING_FLAG]: false,
          [FINISHED_FLAG]: null,
          [ERROR_FLAG]: null,
          entities: {
            ...state.entities,
            [action.payload.id]: {
              ...state.entities[action.payload.id],
              [LOADING_FLAG]: true,
              [PROCESSING_FLAG]: false,
              [FINISHED_FLAG]: false,
              [ERROR_FLAG]: null,
            }
          }
        };
      }
      case loadedEntitySuffixRe.test(action.type): {
        if (!(action.payload && action.payload.id)) {
          console.warn('Missing action.payload.id, skipping ho-reducer', action);
          return {
            ...state,
            [LOADING_FLAG]: false,
            [PROCESSING_FLAG]: false,
            [ERROR_FLAG]: null,
            [FINISHED_FLAG]: true,
          };
        }

        return {
          ...state,
          [LOADING_FLAG]: false,
          [PROCESSING_FLAG]: false,
          [FINISHED_FLAG]: null,
          [ERROR_FLAG]: null,
          entities: {
            ...state.entities,
            [action.payload.id]: {
              ...state.entities[action.payload.id],
              [LOADING_FLAG]: false,
              [PROCESSING_FLAG]: false,
              [FINISHED_FLAG]: true,
              [ERROR_FLAG]: null,
            }
          }
        };
      }
      case loadEntityFailedSuffixRe.test(action.type): {
        if (!(action.payload && action.payload.id)) {
          console.warn('Missing action.payload.id, skipping ho-reducer', action);
          return {
            ...state,
            [LOADING_FLAG]: false,
            [PROCESSING_FLAG]: false,
            [FINISHED_FLAG]: true,
            [ERROR_FLAG]: action.error,
          };
        }

        return {
          ...state,
          [LOADING_FLAG]: false,
          [PROCESSING_FLAG]: false,
          [FINISHED_FLAG]: null,
          [ERROR_FLAG]: null,
          entities: {
            ...state.entities,
            [action.payload.id]: {
              ...state.entities[action.payload.id],
              [LOADING_FLAG]: false,
              [PROCESSING_FLAG]: false,
              [FINISHED_FLAG]: true,
              [ERROR_FLAG]: action.error,
            }
          }
        };
      }
      case loadEntityFinallySuffixRe.test(action.type): {
        if (!(action.payload && action.payload.id)) {
          console.warn('Missing action.payload.id, skipping ho-reducer', action);
          return {
            ...state,
            [LOADING_FLAG]: false,
            [PROCESSING_FLAG]: false,
            [FINISHED_FLAG]: true,
          };
        }

        return {
          ...state,
          [LOADING_FLAG]: false,
          [PROCESSING_FLAG]: false,
          [FINISHED_FLAG]: null,
          [ERROR_FLAG]: null,
          entities: {
            ...state.entities,
            [action.payload.id]: {
              ...state.entities[action.payload.id],
              [LOADING_FLAG]: false,
              [PROCESSING_FLAG]: false,
              [FINISHED_FLAG]: true,
            }
          }
        };
      }
      case resetEntityErrorSuffixRe.test(action.type): {
        if (!(action.payload && action.payload.id)) {
          console.warn('Missing action.payload.id, skipping ho-reducer', action);
          return state;
        }

        return {
          ...state,
          entities: {
            ...state.entities,
            [action.payload.id]: {
              ...state.entities[action.payload.id],
              [ERROR_FLAG]: null
            }
          }
        };
      }
      case loadingEntitiesSuffixRe.test(action.type): {
        return {
          ...state,
          [LOADING_FLAG]: true,
          [PROCESSING_FLAG]: false,
          [FINISHED_FLAG]: false,
          [ERROR_FLAG]: null
        };
      }
      case loadedEntitiesSuffixRe.test(action.type): {
        return {
          ...state,
          [LOADING_FLAG]: false,
          [PROCESSING_FLAG]: false,
          [FINISHED_FLAG]: true,
          [ERROR_FLAG]: null,
          entities: state.ids.reduce((acc, curr) => {
            if (!acc[curr].entity) {
              acc[curr] = {
                ...acc[curr],
                [LOADING_FLAG]: false,
                [PROCESSING_FLAG]: false,
                [FINISHED_FLAG]: null,
                [ERROR_FLAG]: null,
              };
            }
            return acc;
          }, state.entities || {})
        };
      }
      case loadEntitiesFailedSuffixRe.test(action.type): {
        return {
          ...state,
          [LOADING_FLAG]: false,
          [PROCESSING_FLAG]: false,
          [FINISHED_FLAG]: true,
          [ERROR_FLAG]: action.error
        };
      }
      case loadEntitiesFinallySuffixRe.test(action.type): {
        return {
          ...state,
          [LOADING_FLAG]: false,
          [PROCESSING_FLAG]: false,
          [FINISHED_FLAG]: true,
        };
      }
      case resetEntitiesErrorSuffixRe.test(action.type): {
        return {
          ...state,
          [ERROR_FLAG]: null,
        };
      }
      case processingEntitySuffixRe.test(action.type): {
        if (!(action.payload && action.payload.id)) {
          if (!action.payload.isNew) {
            console.warn('Missing action.payload.id, skipping ho-reducer', action);
          }
          return {
            ...state,
            [LOADING_FLAG]: false,
            [PROCESSING_FLAG]: true,
            [FINISHED_FLAG]: false,
            [ERROR_FLAG]: null,
          };
        }

        return {
          ...state,
          [LOADING_FLAG]: false,
          [PROCESSING_FLAG]: false,
          [FINISHED_FLAG]: null,
          [ERROR_FLAG]: null,
          entities: {
            ...state.entities,
            [action.payload.id]: {
              ...state.entities[action.payload.id],
              [LOADING_FLAG]: false,
              [PROCESSING_FLAG]: true,
              [FINISHED_FLAG]: false,
              [ERROR_FLAG]: null,
            }
          }
        };
      }
      case processedEntitySuffixRe.test(action.type): {
        if (!(action.payload && action.payload.id)) {
          if (!action.payload.isNew) {
            console.warn('Missing action.payload.id, skipping ho-reducer', action);
          }
          return {
            ...state,
            [LOADING_FLAG]: false,
            [PROCESSING_FLAG]: false,
            [FINISHED_FLAG]: true,
            [ERROR_FLAG]: null,
          };
        }

        return {
          ...state,
          [LOADING_FLAG]: false,
          [PROCESSING_FLAG]: false,
          [FINISHED_FLAG]: null,
          [ERROR_FLAG]: null,
          entities: {
            ...state.entities,
            [action.payload.id]: {
              ...state.entities[action.payload.id],
              [LOADING_FLAG]: false,
              [PROCESSING_FLAG]: false,
              [FINISHED_FLAG]: true,
              [ERROR_FLAG]: null,
            }
          }
        };
      }
      case processEntityFailedSuffixRe.test(action.type): {
        if (!(action.payload && action.payload.id)) {
          if (!action.payload.isNew) {
            console.warn('Missing action.payload.id, skipping ho-reducer', action);
          }
          return {
            ...state,
            [LOADING_FLAG]: false,
            [PROCESSING_FLAG]: false,
            [FINISHED_FLAG]: true,
            [ERROR_FLAG]: action.error,
          };
        }

        return {
          ...state,
          [LOADING_FLAG]: false,
          [PROCESSING_FLAG]: false,
          [FINISHED_FLAG]: null,
          [ERROR_FLAG]: null,
          entities: {
            ...state.entities,
            [action.payload.id]: {
              ...state.entities[action.payload.id],
              [LOADING_FLAG]: false,
              [PROCESSING_FLAG]: false,
              [FINISHED_FLAG]: true,
              [ERROR_FLAG]: action.error,
            }
          }
        };
      }
      case processEntityFinallySuffixRe.test(action.type): {
        if (!(action.payload && action.payload.id)) {
          if (!action.payload.isNew) {
            console.warn('Missing action.payload.id, skipping ho-reducer', action);
          }
          return {
            ...state,
            [LOADING_FLAG]: false,
            [PROCESSING_FLAG]: false,
            [FINISHED_FLAG]: true,
          };
        }

        return {
          ...state,
          [LOADING_FLAG]: false,
          [PROCESSING_FLAG]: false,
          [FINISHED_FLAG]: null,
          [ERROR_FLAG]: null,
          entities: {
            ...state.entities,
            [action.payload.id]: {
              ...state.entities[action.payload.id],
              [LOADING_FLAG]: false,
              [PROCESSING_FLAG]: false,
              [FINISHED_FLAG]: true,
            }
          }
        };
      }
      case processingEntitiesSuffixRe.test(action.type): {
        return {
          ...state,
          [LOADING_FLAG]: false,
          [PROCESSING_FLAG]: true,
          [FINISHED_FLAG]: false,
          [ERROR_FLAG]: null
        };
      }
      case processedEntitiesSuffixRe.test(action.type): {
        return {
          ...state,
          [LOADING_FLAG]: false,
          [PROCESSING_FLAG]: false,
          [FINISHED_FLAG]: null,
          [ERROR_FLAG]: null,
          entities: state.ids.reduce((acc, curr) => {
            if (!acc[curr].entity) {
              acc[curr] = {
                ...acc[curr],
                [LOADING_FLAG]: false,
                [PROCESSING_FLAG]: false,
                [FINISHED_FLAG]: true,
                [ERROR_FLAG]: null,
              };
            }
            return acc;
          }, state.entities || {})
        };
      }
      case processEntitiesFailedSuffixRe.test(action.type): {
        return {
          ...state,
          [LOADING_FLAG]: false,
          [PROCESSING_FLAG]: false,
          [FINISHED_FLAG]: true,
          [ERROR_FLAG]: action.error
        };
      }
      case processEntitiesFinallySuffixRe.test(action.type): {
        return {
          ...state,
          [LOADING_FLAG]: false,
          [PROCESSING_FLAG]: false,
          [FINISHED_FLAG]: true,
        };
      }

      default:
        return state;
    }
  };

  const createCustomAction = name => `${actionNamespace}_${name}`;

  const createLoadEntityActions = (name = '') => [
    `${actionNamespace}_${name}_${loadEntitySuffix}`,
    `${actionNamespace}_${name}_${loadingEntitySuffix}`,
    `${actionNamespace}_${name}_${loadedEntitySuffix}`,
    `${actionNamespace}_${name}_${loadEntityFailedSuffix}`,
    `${actionNamespace}_${name}_${loadEntityFinallySuffix}`,
  ];

  const createLoadEntitiesActions = (name = '') => [
    `${actionNamespace}_${name}_${loadEntitiesSuffix}`,
    `${actionNamespace}_${name}_${loadingEntitiesSuffix}`,
    `${actionNamespace}_${name}_${loadedEntitiesSuffix}`,
    `${actionNamespace}_${name}_${loadEntitiesFailedSuffix}`,
    `${actionNamespace}_${name}_${loadEntitiesFinallySuffix}`,
  ];

  const createProcessEntityActions = (name = '') => [
    `${actionNamespace}_${name}_${processEntitySuffix}`,
    `${actionNamespace}_${name}_${processingEntitySuffix}`,
    `${actionNamespace}_${name}_${processedEntitySuffix}`,
    `${actionNamespace}_${name}_${processEntityFailedSuffix}`,
    `${actionNamespace}_${name}_${processEntityFinallySuffix}`,
  ];

  const createProcessEntitiesActions = (name = '') => [
    `${actionNamespace}_${name}_${processEntitiesSuffix}`,
    `${actionNamespace}_${name}_${processingEntitiesSuffix}`,
    `${actionNamespace}_${name}_${processedEntitiesSuffix}`,
    `${actionNamespace}_${name}_${processEntitiesFailedSuffix}`,
    `${actionNamespace}_${name}_${processEntitiesFinallySuffix}`,
  ];

  const resetEntityErrorAction = entityId => ({
    type: `${actionNamespace}_${resetEntityErrorSuffix}`,
    payload: {
      id: entityId
    }
  });

  const resetEntitiesErrorAction = () => ({
    type: `${actionNamespace}_${resetEntitiesErrorSuffix}`
  });

  const defaultFilter = () => true;
  const getEntities = (state, filter = defaultFilter) => ({
    [LOADING_FLAG]: state[stateNamespace][LOADING_FLAG],
    [PROCESSING_FLAG]: state[stateNamespace][PROCESSING_FLAG],
    [ERROR_FLAG]: state[stateNamespace][ERROR_FLAG],
    [FINISHED_FLAG]: state[stateNamespace][FINISHED_FLAG],
    entities: state[stateNamespace].ids.map(id => state[stateNamespace].entities[id]).filter(item => filter(item))
  });

  const isProcessing = state => state[stateNamespace][PROCESSING_FLAG];
  const isLoading = state => state[stateNamespace][LOADING_FLAG];
  const hasError = state => state[stateNamespace][ERROR_FLAG];
  const isFinished = state => state[stateNamespace][FINISHED_FLAG];

  const isProcessingEntity = (state, entityId) =>
    state[stateNamespace].entities && state[stateNamespace].entities[entityId]
      ? state[stateNamespace].entities[entityId][PROCESSING_FLAG]
      : false;

  const isLoadingEntity = (state, entityId) =>
    state[stateNamespace].entities && state[stateNamespace].entities[entityId]
      ? state[stateNamespace].entities[entityId][LOADING_FLAG]
      : false;

  const hasEntityError = (state, entityId) =>
    state[stateNamespace].entities && state[stateNamespace].entities[entityId]
      ? state[stateNamespace].entities[entityId][ERROR_FLAG]
      : false;

  const isEntityFinished = (state, entityId) =>
    state[stateNamespace].entities && state[stateNamespace].entities[entityId]
      ? state[stateNamespace].entities[entityId][FINISHED_FLAG]
      : false;

  return {
    createReducer,
    actionNamespace,
    createCustomAction,
    createLoadEntityActions,
    createLoadEntitiesActions,
    createProcessEntityActions,
    createProcessEntitiesActions,
    getEntities,
    isProcessing,
    isLoading,
    hasError,
    isFinished,
    isProcessingEntity,
    isLoadingEntity,
    hasEntityError,
    isEntityFinished,
    resetEntityErrorAction,
    resetEntitiesErrorAction,
  };
};

const flagsPropTypes = {
  [LOADING_FLAG]: PropTypes.bool,
  [PROCESSING_FLAG]: PropTypes.bool,
  [FINISHED_FLAG]: PropTypes.bool,
  [ERROR_FLAG]: PropTypes.string
};

const flagsDefaultProps = {
  [LOADING_FLAG]: false,
  [PROCESSING_FLAG]: false,
  [FINISHED_FLAG]: null,
  [ERROR_FLAG]: null
};

export const getEntityPropTypes = entityProps => PropTypes.shape({
  ...flagsPropTypes,
  ...entityProps
});

export const getEntityDefaultProps = entityDefaults => ({
  ...flagsDefaultProps,
  ...entityDefaults
});

export const getEntitiesListPropTypes = entityProps => PropTypes.shape({
  ...flagsPropTypes,
  entities: PropTypes.arrayOf(PropTypes.shape({
    ...flagsPropTypes,
    ...entityProps
  }))
});

export const getEntitiesListDefaultProps = () => ({
  ...flagsDefaultProps,
  entities: []
});

export const getEntitiesMapPropTypes = entityProps => PropTypes.shape({
  [PropTypes.string]: PropTypes.shape({
    ...flagsPropTypes,
    ...entityProps
  })
});
